import { grey } from "@mui/material/colors";
import { DataGrid } from "@mui/x-data-grid";
import { arrType, converAttrToDatagridCol, datatypes, inputTypes, selectOptionsKeyName } from "data/globalData";
import { totalSizeRatioColumn } from "../../data";
import { convertSizeStringToStandardInputFormat, convertWarehouseStringToStandardInputFormat, orderQtyStaticColumns } from "../data";

import { Box, Typography, Stack, Button, Tooltip } from "@mui/material";
import DisplayTable from "components/ReusableComponents/DisplayTable";
import { GlobalState } from "context/GlobalContext";
import { ContentPasteRounded } from "@mui/icons-material";

const ChannelQtyWarehouseSplit = ({
	tableColumns,
	channel,
	whSplitRows,
	channelQtyData,
	handleDataChange,
	allChannels,
	allSizes,
	allWarehouses = [],
	editMode = false,
	handleBulkPaste,
}) => {
	const { snackBar, setSnackBar, setSnackBarOpen } = GlobalState();
	const tableRowsState = Object.values(
		whSplitRows
			.filter((row) => row.channel === channel)
			.reduce((acc, curr) => {
				acc[curr.warehouse] = curr;
				return acc;
			}, {})
	);
	const tableWhQtyDisplayRows = Object.values(
		whSplitRows
			.filter((row) => row.channel === channel)
			.reduce((acc, row) => {
				if (acc[row.size] === undefined) acc[row.size] = { size: row.size };

				acc[row.size] = {
					...acc[row.size],
					[row.warehouse]: row.qty,
				};
				return acc;
			}, {})
	);

	const handleRowDataChange = (newRow, oldRow) => {
		return handleDataChange(newRow, oldRow, channel);
	};

	const handlePaste = async () => {
		const text = await navigator.clipboard.readText();
		const pastedRows = [];
		text.trim().split("\n").forEach((line) => {
			const cols = line.split("\t");
			const warehouse = cols[0]?.trim();
			const warehouse_qty_precent = parseFloat(cols[1]);
			if (!warehouse || !isFinite(warehouse_qty_precent)) return;
			const existingRow = tableRowsState.find((r) => r.warehouse === warehouse);
			if (!existingRow) return;
			pastedRows.push({ warehouse, warehouse_qty_precent });
		});
		const matched = pastedRows.length;
		setSnackBarOpen(true);
		if (matched === 0) {
			setSnackBar({ ...snackBar, message: "No matching warehouse names found in clipboard", severity: "error", anchorOrigin: { horizontal: "center", vertical: "top" } });
			return;
		}
		handleBulkPaste(pastedRows, channel);
		setSnackBar({ ...snackBar, message: `Pasted successfully (${matched} rows updated)`, severity: "success", anchorOrigin: { horizontal: "center", vertical: "top" } });
	};

	return (
		<Stack width="100%" spacing={2}>
			<Typography variant="h6" mr={2}>
				Warehouse Split - {channel}
			</Typography>
			<Box>
				<Box display="flex" alignItems="center" gap={1} mb={0.5}>
					<Typography variant="body1">Ratio</Typography>
					{editMode && (
						<Tooltip title="Paste from Excel">
							<Button size="small" variant="outlined" startIcon={<ContentPasteRounded fontSize="small" />} onClick={handlePaste}>Paste</Button>
						</Tooltip>
					)}
				</Box>
				<DataGrid
					rows={tableRowsState ? tableRowsState : []}
					getRowId={(row) => row.warehouse}
					columns={tableColumns.map((col) => converAttrToDatagridCol(col))}
					sx={{
						width: "70%",
						// maxHeight: 250,
						"& .MuiDataGrid-row": {
							cursor: "pointer",
						},
						"& .MuiDataGrid-row:hover": {
							backgroundColor: "transparent",
						},
						"& .MuiDataGrid-columnHeader": {
							cursor: "pointer",
							background: grey[400],
							textTransform: "uppercase",
						},
						"& .MuiDataGrid-cell": {
							padding: 0,
						},
					}}
					density="compact"
					disableRowSelectionOnClick
					pagination={false} // Remove footer
					hideFooter={true}
					showCellVerticalBorder
					showColumnVerticalBorder
					isCellEditable={({ row }) => editMode}
					processRowUpdate={handleRowDataChange}
					autoHeight
				/>
			</Box>

			<Box width={300}>
				<Typography variant="body1" mr={2}>
					Size Qty Split
				</Typography>
				<DisplayTable
					size="small"
					textAlign="center"
					columns={[
						{
							name: "Size",
							key: "size",
							data_type: datatypes.STRING.key,
							input_type: inputTypes.ENTER.key,
							renderHeader: (col) => (
								<Box
									sx={{
										display: "flex",
										justifyContent: "center",
										width: "100%",
										alignItems: "center",
										background: grey[400],
										p: 1,
										boxSizing: "border-box",
									}}>
									<span>{col.name}</span>
								</Box>
							),
						},
						...allWarehouses.map((wh) => convertWarehouseStringToStandardInputFormat(wh)),
					]}
					rows={tableWhQtyDisplayRows}
					// rows={[
					// 	{
					// 		size: "total",
					// 		size_qty: channelQtyData
					// 			?.filter((row) => row.channel === channel)
					// 			.map((row) => +row.size_qty)
					// 			.reduce((acc, curr) => acc + curr, 0),
					// 	},
					// 	...channelQtyData
					// 		?.filter((row) => row.channel === channel)
					// 		.map((row) => {
					// 			let { size, size_qty, ...rest } = row;

					// 			return { size, size_qty };
					// 		}),
					// ]}
				/>
			</Box>
		</Stack>
	);
};

export default ChannelQtyWarehouseSplit;
